module.exports = __webpack_public_path__ + "img/Cutaways_house_3_a.9f4c8400.jpg";